<app-abstract-action-confirmation-dialog
  (acceptEvent)="onAcceptClickedHandler()"
  (closeEvent)="onCloseClickedHandler()"
  (declineEvent)="onDeclineClickedHandler()"
  [acceptLabel]="data.acceptLabel"
  [cdkFocusInitialOnCancelButtonFlag]="data.cdkFocusInitialOnCancelButtonFlag"
  [declineLabel]="data.declineLabel"
  [formGroup]="formGroup"
  [formInvalidFlag]="formGroup.invalid"
  [messageLine1]="data.messageLine1"
  [messageLine2]="data.messageLine2"
  [note]="data.note"
  [subMessageLine1]="data.subMessageLine1"
  [subMessageLine2]="data.subMessageLine2"
>
  <div popup-form>
    <form [formGroup]="formGroup">
      @if (data.optionFlag) {
        <div class="sub-message">
          <mat-slide-toggle formControlName="optionValueFlag" matInput>
            <div class="option-message fxl-column">
              <span>{{ data.optionLabel }}</span>
              @if (data.optionSubLabel) {
                <span class="sub-label primary-fg">{{ data.optionSubLabel }}</span>
              }
            </div>
          </mat-slide-toggle>
        </div>
      }
    </form>
  </div>
</app-abstract-action-confirmation-dialog>
